$(document).ready(function(){
    /* Get iframe src attribute value i.e. YouTube video url
    and store it in a variable */
    var url = $("#mcpvpop").attr('src');
    
    /* Assign empty url value to the iframe src attribute when
    modal hide, which stop the video playing */
    $("#mcpvm").on('hide.bs.modal', function(){
        $("#mcpvpop").attr('src', '');
    });
    
    /* Assign the initially stored url back to the iframe src
    attribute when modal is displayed again */
    $("#mcpvm").on('show.bs.modal', function(){
        $("#mcpvpop").attr('src', url);
    });
});